import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromEmployeeMainReducer from '../employee-detail.reducer';
import { RestoreCustomerState, restoreCustomerFeatureKey } from '../reducers/restore-customer.reducer';
import * as restoreCustomerState from '../reducers/restore-customer.reducer';

//#region Employee detail ROOT STATE
export const getMainEmployeeState = createFeatureSelector<fromEmployeeMainReducer.State, fromEmployeeMainReducer.EmployeeDetailMainState>(
  fromEmployeeMainReducer.employeeDetailFeatureKey
);
//#endregion

//#region Restore Customer SUB STATE
export const getRestoreCustomerState = createSelector(getMainEmployeeState, state => state[restoreCustomerFeatureKey]);
//#endregion

//#region Restore Customer SUB STATE
export const getRestoreCustomerRequest = createSelector(getRestoreCustomerState, restoreCustomerState.restoreCustomerRequestState);
export const getRestoreCustomerSuccess = createSelector(getRestoreCustomerState, restoreCustomerState.restoreCustomerResponse);
export const getRestoreCustomerFailure = createSelector(getRestoreCustomerState, restoreCustomerState.restoreCustomerFailureState);

export const getRestoreCustomerIsLoaded = createSelector(getRestoreCustomerState, restoreCustomerState.getRestoreCustomerIsLoaded);
//#endregion
